import "../AvailableSlot/NextAvailableSlot.css";

import React from "react";
import moment from "moment-timezone";

const getNowByTimezone = (timezone) => {
  return moment.tz(timezone).toDate();
};

/* ===========================

   WEEKDAY MAP

=========================== */

const daysOfWeek = {
  Sunday: 0,

  Monday: 1,

  Tuesday: 2,

  Wednesday: 3,

  Thursday: 4,

  Friday: 5,

  Saturday: 6,
};

/* ===========================

   NEXT DATE FOR DAY

=========================== */

const getNextDateForDay = (dayName, nowIst) => {
  const target = daysOfWeek[dayName];

  if (target === undefined) return null;

  const d = new Date(nowIst);

  const todayIndex = d.getDay();

  const diff = (target - todayIndex + 7) % 7;

  d.setDate(d.getDate() + diff);

  d.setHours(0, 0, 0, 0);

  return d;
};

/* ===========================

   EXTRACT START TIME

=========================== */

const extractStartString = (slotText) => {
  if (!slotText) return null;

  const m = slotText.match(/(\d{1,2}[:.]\d{2}\s*[APap][Mm])/);

  return m ? m[1].replace(".", ":").replace(/\s+/g, "") : null;
};

        const extractEndString = (slotText) => {
  if (!slotText) return null;

  const m = slotText.match(
    /-\s*(\d{1,2}[:.]\d{2}\s*[APap][Mm])/
  );

  return m ? m[1].replace(".", ":").replace(/\s+/g, "") : null;
};


/* ===========================

   PARSE TIME

=========================== */

const parseTimeParts = (timeStr) => {
  if (!timeStr) return null;

  const m = timeStr.match(/^(\d{1,2}):(\d{2})([APap][Mm])$/);

  if (!m) return null;

  let hrs = parseInt(m[1], 10);

  const mins = parseInt(m[2], 10);

  const ampm = m[3].toLowerCase();

  if (ampm === "pm" && hrs < 12) hrs += 12;

  if (ampm === "am" && hrs === 12) hrs = 0;

  return { hrs, mins };
};

/* ===========================

   BUILD SLOT DATE

=========================== */
const buildDateForSlot = (
  dayName,
  startTimeStr,
  tutorTimezone,
  viewerTimezone
) => {
 const nowViewer = moment.tz(
  viewerTimezone || tutorTimezone
);

  const targetDay = daysOfWeek[dayName];

  if (targetDay === undefined) return null;

  let diff = targetDay - nowViewer.day();

if (diff < 0) {
  diff += 7;
}
  const slotDate = nowViewer.clone().add(diff, "days");

  const parts = parseTimeParts(startTimeStr);

  if (!parts) return null;

  slotDate.hour(parts.hrs);
  slotDate.minute(parts.mins);
  slotDate.second(0);
  slotDate.millisecond(0);

  // if today's slot already crossed in viewer timezone
  const compareNow = nowViewer.clone();

compareNow.seconds(0);
compareNow.milliseconds(0);

if (diff === 0) {
  const slotMoment = slotDate.clone();

  if (
    viewerTimezone &&
    slotMoment.isBefore(compareNow)
  ) {
    slotDate.add(7, "days");
  }
}

  return slotDate.toDate();
};

export const checkAvailability = (timings = [], tutorTimezone, viewerTimezone) => {
  // const timezone = viewerTimezone;
  const timezone = viewerTimezone || tutorTimezone;

const nowIst = getNowByTimezone(timezone);

  for (const timing of timings) {
    if (!timing?.day || !timing?.slots) continue;

    for (const slot of timing.slots) {
      if (slot?.isBooked === false && slot?.timing) {
        const startStr = extractStartString(slot.timing);


        if (!startStr) continue;

        const slotDate = buildDateForSlot(
  timing.day,
  startStr,
  tutorTimezone,
  viewerTimezone
);

        if (slotDate && slotDate > nowIst) {
          return true;
        }
      }
    }
  }

  return false;
};

const prettyTime = (date, timezone) =>
  date
    ? date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: timezone,
      })
    : "";
const prettyDateLabel = (date, nowIst, timezone) => {
  const dOnly = new Date(date);

  dOnly.setHours(0, 0, 0, 0);

  const nowOnly = new Date(nowIst);

  nowOnly.setHours(0, 0, 0, 0);

  const diff = (dOnly.getTime() - nowOnly.getTime()) / (1000 * 60 * 60 * 24);

  if (diff === 0) return "Today";

  if (diff === 1) return "Tomorrow";

  return date.toLocaleDateString("en-US", {
    month: "short",

    day: "numeric",

    timeZone: timezone,
  });
};

const NextAvailableSlot = ({
  timings = [],
  bot_id,
  botdata,
  hasTiming,
  onlineOffline,
  tutorTimezone,
  viewerTimezone,
}) => {
  const isAiBot = !!bot_id;
  const isAiTwin = !!bot_id && !!botdata?.user_id;

  // console.log("NextAvailableSlot Props:", {
  //   timings,
  //   bot_id,
  //   botdata,
  //   hasTiming,
  //   onlineOffline,
  // });

  console.log("Viewer Timezone:", viewerTimezone);
  console.log("Tutor Timezone:", tutorTimezone);

  const timezone = viewerTimezone || tutorTimezone;

  const nowIst = moment.tz(timezone).toDate();

  let earliest = null;

  for (const timing of timings) {
    if (!timing?.day || !timing?.slots) continue;

    for (const slot of timing.slots) {
      if (slot?.isBooked === false && slot?.timing) {
   const startStr = extractStartString(slot.timing);
const endStr = extractEndString(slot.timing);

if (!startStr || !endStr) continue;

const slotDate = buildDateForSlot(
  timing.day,
  startStr,
  tutorTimezone,
  viewerTimezone
);

        if (!slotDate) continue;

        if (!earliest || slotDate < earliest.date) {
          earliest = { date: slotDate };
        }
      }
    }
  }

  // ✅ FIRST → show real timing
  if (earliest && hasTiming && onlineOffline) {
  const label = prettyDateLabel(
  earliest.date,
  nowIst,
  timezone
);

const time = prettyTime(
  earliest.date,
  timezone
);
    return (
      <div className="text-end">
        <span className="normal-text">Available</span>
        <br />
        <span className="bold-text">
          {label}
          {label === "Today" && `, ${time}`}
        </span>
      </div>
    );
  }

  // ✅ AI Twin fallback
  if (isAiTwin) {
    return (
      <div className="text-end">
        <span className="normal-text">AI Twin</span>
        <br />
        <span className="bold-text">Available</span>
      </div>
    );
  }

  // ✅ AI Bot fallback
  if (isAiBot) {
    return (
      <div className="text-end">
        <span className="normal-text">Available</span>
        <br />
        <span className="bold-text">Anytime</span>
      </div>
    );
  }

  return (
    <div className="text-end">
      <span className="normal-text">Currently</span>
      <br />
      <span className="bold-text">Unavailable</span>
    </div>
  );
};

export default NextAvailableSlot;
// if(hasTiming || onlineOffline) {
//   const label = prettyDateLabel(earliest.date, nowIst)
//   const time = prettyTime(earliest.date)
//   return(
//     <div className='text-end'>
//       <span className='normal-text'>Available</span>
//       <br />
//        <span className='bold-text'>
//         {label}
//         {label === 'Today' && `, ${time}`}
//       </span>
//     </div>
//   )
// }
